import * as React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { UserProvider } from '@/contexts/user-context';
import { LocalizationProvider } from '@/components/core/localization-provider';
import { ThemeProvider } from '@/components/core/theme-provider/theme-provider';

// Import các pages
import HomePage from './pages/HomePage';
import SignInPage from './pages/auth/SignInPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import DashboardLayout from './pages/dashboard/DashboardLayout';
import DashboardOverview from './pages/dashboard/DashboardOverview';
import AccountPage from './pages/dashboard/AccountPage';
import ClubPage from './pages/dashboard/ClubPage';
import IntegrationsPage from './pages/dashboard/IntegrationsPage';
import KycPage from './pages/dashboard/KycPage';
import PlayerPage from './pages/dashboard/PlayerPage';
import SettingsPage from './pages/dashboard/SettingsPage';
import WithdrawPage from './pages/dashboard/WithdrawPage';
import NotFoundPage from './pages/errors/NotFoundPage';

function App(): React.JSX.Element {
  return (
      <LocalizationProvider>
        <UserProvider>
          <ThemeProvider>
            <Routes>
              {/* Home page */}
              <Route path="/" element={<HomePage />} />
              
              {/* Auth routes */}
              <Route path="/auth/sign-in" element={<SignInPage />} />
              <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
              
              {/* Dashboard routes */}
              <Route path="/dashboard" element={<DashboardLayout />}>
                <Route index element={<DashboardOverview />} />
                <Route path="account" element={<AccountPage />} />
                <Route path="club" element={<ClubPage />} />
                <Route path="integrations" element={<IntegrationsPage />} />
                <Route path="kyc" element={<KycPage />} />
                <Route path="player" element={<PlayerPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="withdraw" element={<WithdrawPage />} />
              </Route>
              
              {/* Error routes */}
              <Route path="/errors/not-found" element={<NotFoundPage />} />
              
              {/* Catch all - redirect to not found */}
              <Route path="*" element={<Navigate to="/errors/not-found" replace />} />
            </Routes>
          </ThemeProvider>
        </UserProvider>
      </LocalizationProvider>
  );
}

export default App;
